import { LockClosedIcon } from '@/components/icons/lock-closed';
import { Typography } from '@/components/ui/typography';
import { cn } from '@/utils/classnames';

interface LockedOverlayProps {
  /** Names what unlocks the content — the only non-visual cue that it is locked. */
  message: React.ReactNode;
  children: React.ReactNode;
  /** Figma overlay height and any extra frame classes. */
  className?: string;
}

export function LockedOverlay({
  message,
  children,
  className,
}: LockedOverlayProps) {
  return (
    <div
      data-testid="locked-overlay"
      className={cn('relative overflow-hidden rounded-lg', className)}
    >
      <div className="pointer-events-none size-full select-none [&>*]:size-full">
        {children}
      </div>

      <div className="absolute inset-0 flex items-center justify-center bg-white/50 backdrop-blur-[3px]">
        <div className="border-fx-neutral-200 shadow-dropdown flex items-center gap-2 rounded-full border bg-white px-3 py-2">
          <LockClosedIcon className="text-fx-neutral-600 size-4 shrink-0" />
          <Typography variant="medium2" className="!text-fx-neutral-600">
            {message}
          </Typography>
        </div>
      </div>
    </div>
  );
}
